/**
 * @generated SignedSource<<2f2d6df043496188995ab8df4c8e8d8f>>
 * @relayHash adfe09a7742646fb90e2c99abadef611
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 90b09e75f08905e0f72ae32c810a0a8dfeecd094551eac2513d02943f5c485a9

import type { ConcreteRequest, GraphQLSubscription } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueExportType = "CSV_ALL_FIELDS" | "CSV_CURRENT_FIELDS" | "CSV_FILTER_DEFAULT_FIELDS" | "CSV_WITH_BOM_ALL_FIELDS" | "CSV_WITH_BOM_CURRENT_FIELDS" | "CSV_WITH_BOM_FILTER_DEFAULT_FIELDS" | "%future added value";
export type JiraIssueSearchOperationScope = "NIN_GLOBAL" | "NIN_GLOBAL_SCHEMA_REFACTOR" | "NIN_GLOBAL_SHADOW_REQUEST" | "NIN_PROJECT" | "NIN_PROJECT_SCHEMA_REFACTOR" | "NIN_PROJECT_SHADOW_REQUEST" | "TIMELINE_PROJECT" | "%future added value";
export type JiraIssueExportInput = {
  cloudId: string;
  excludeDoneWorkItems?: boolean | null | undefined;
  exportType?: JiraIssueExportType | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  maxResults?: number | null | undefined;
  modified?: boolean | null | undefined;
  pagerStart?: number | null | undefined;
  scope?: JiraIssueSearchScope | null | undefined;
};
export type JiraIssueSearchScope = {
  operationScope?: JiraIssueSearchOperationScope | null | undefined;
  projectKey?: string | null | undefined;
};
export type exportIssuesTaskFlagSubscription$variables = {
  input: JiraIssueExportInput;
};
export type exportIssuesTaskFlagSubscription$data = {
  readonly jira: {
    readonly onIssueExported: {
      readonly __typename: string;
      readonly task?: {
        readonly id: string | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues" | "exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues" | "exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues">;
    } | null | undefined;
  } | null | undefined;
};
export type exportIssuesTaskFlagSubscription = {
  response: exportIssuesTaskFlagSubscription$data;
  variables: exportIssuesTaskFlagSubscription$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v3 = {
  "concreteType": "JiraIssueExportTask",
  "kind": "LinkedField",
  "name": "task",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    }
  ]
},
v4 = [
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "exportIssuesTaskFlagSubscription",
    "selections": [
      {
        "concreteType": "JiraSubscription",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "onIssueExported",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "exportIssuesTaskProgressFlag_issueNavigatorActionExportIssues"
              },
              {
                "kind": "FragmentSpread",
                "name": "exportIssuesTaskDownloadFlag_issueNavigatorActionExportIssues"
              },
              {
                "kind": "FragmentSpread",
                "name": "exportIssuesTaskErrorFlag_issueNavigatorActionExportIssues"
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "JiraIssueExportTaskCompleted"
              }
            ]
          }
        ]
      }
    ],
    "type": "Subscription"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "exportIssuesTaskFlagSubscription",
    "selections": [
      {
        "concreteType": "JiraSubscription",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "kind": "LinkedField",
            "name": "onIssueExported",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isJiraIssueExportEvent"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "progress"
                  }
                ],
                "type": "JiraIssueExportTaskProgress"
              },
              {
                "kind": "InlineFragment",
                "selections": (v4/*: any*/),
                "type": "JiraIssueExportTaskSubmitted"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "downloadResultUrl"
                  }
                ],
                "type": "JiraIssueExportTaskCompleted"
              },
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "concreteType": "JiraIssueExportTaskProgress",
                    "kind": "LinkedField",
                    "name": "taskProgress",
                    "plural": false,
                    "selections": (v4/*: any*/)
                  },
                  {
                    "concreteType": "JiraIssueExportError",
                    "kind": "LinkedField",
                    "name": "error",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "displayMessage"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "errorType"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "statusCode"
                      }
                    ]
                  }
                ],
                "type": "JiraIssueExportTaskTerminated"
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "90b09e75f08905e0f72ae32c810a0a8dfeecd094551eac2513d02943f5c485a9",
    "metadata": {},
    "name": "exportIssuesTaskFlagSubscription",
    "operationKind": "subscription",
    "text": null
  }
};
})();

(node as any).hash = "33e0edd502a7e443e2e99f8529ba470d";

export default node;
